import * as React from "react";
import { embedDashboard } from "@preset-sdk/embedded";
import { useNavigate, useParams } from "react-router-dom";
import AnalyticsService from "../../../services/AnalyticsService";
import {
  FormControl,
  IconButton,
  InputLabel,
  MenuItem,
  OutlinedInput,
  Select,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import PersonService from "../../../services/PersonService";
import { Box } from "@mui/system";

const ViewSuperSet = () => {
  const styles = {
    dashboard: {
      width: "100%",
      height: "1300px",
    },
  };

  let { customerId } = useParams();
  let navigate = useNavigate();
  const [selectedBank, setSelectedBank] = React.useState({
    consentId: null,
    brand: null,
  });
  const [filter, setFilter] = React.useState(false);
  const [consents, setConsents] = React.useState([]);

  const selectedBankChange = (event) => {
    setFilter(true);
    setSelectedBank(event.target.value);
  };

  React.useEffect(() => {
    const fetchAnalyticsToken = async () => {
      let consentIds = [];
      if (filter) {
        if (selectedBank) {
          consentIds.push(selectedBank);
        }
      } else {
        const consents = await PersonService.getPersonConsent(customerId);
        const authorizedConsents = consents.filter(
          (consent) => consent.status === "AUTHORIZED"
        );
        setConsents(authorizedConsents);
        if (authorizedConsents.length) {
          setSelectedBank(authorizedConsents[0].consentId);
          consentIds.push(authorizedConsents[0].consentId);
        }
      }

      if (!consentIds.length) {
        return;
      }

      const tokenResponse = await AnalyticsService.getToken(
        customerId,
        consentIds
      );
      const token = tokenResponse.data.token;

      embedDashboard({
        id: "905c4c60-c1da-4b93-8174-dfbf98e92924",
        supersetDomain: process.env.REACT_APP_ANALITICS_API,
        mountPoint: document.getElementById("superset-container"),
        fetchGuestToken: () => token,
        dashboardUiConfig: { hideTitle: true, hideChartControls: true },
      });
      setTimeout(() => {
        const ifr = document
          .getElementById("superset-container")
          .getElementsByTagName("iframe");
        //todo : remover barra de rolagem
        //const ifrsize = document.getElementById("superset-container").getElementById("app")
        ifr[0].style = "width: 100%; height: 100%; border : none";
      }, 100);
    };

    fetchAnalyticsToken();
  }, [customerId, selectedBank, filter]);

  return (
    <div style={{ width: "100%" }}>
      <div
        style={{
          display: "flex",
          flexDirection: "row",
          width: "100%",
          marginBottom: "15px",
        }}
      >
        <div style={{ textAlign: "left", flex: 1 }}>
          <FormControl sx={{ m: 1, width: 300, margin: "0 auto", marginTop: '24px' }}>
            <InputLabel shrink={true}>Instituição</InputLabel>
            <Select
              variant="outlined"
              labelId="demo-multiple-name-label"
              label="Instituição"
              autoFocus={true}
              id="demo-multiple-name"
              value={selectedBank}
              onChange={selectedBankChange}
              input={<OutlinedInput label="Instituição" />}
            >
              {consents.map((bank) => (
                <MenuItem key={bank.uuid} value={bank.consentId}>
                  {bank.brand}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </div>
        <div style={{ textAlign: "right" }}>
          <IconButton
            sx={{ marginTop: "10px" }}
            onClick={() => navigate(`/dashboard`)}
            color="primary"
            aria-label="upload picture"
            component="label"
          >
            <CloseIcon />
          </IconButton>
        </div>
      </div>
      <Box>
        <div style={styles.dashboard} id="superset-container" />
      </Box>
    </div>
  );
};

export default ViewSuperSet;
